import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { SrxApi } from '../../api/SrxApi';

const useUpdateDestruction = () => {
    const { mutate: updateDestruction, isLoading } = useMutation(
        async (payload) => {
            const response = await SrxApi.post('/destructions/update-destruction', payload);
            return response?.data;
        },
        {
            onSuccess: (data) => {
                const message = data?.message ?? data?.data?.message ?? 'Destruction updated successfully!';
                toast.success(message);
            },
            onError: (error) => {
                const errorMessage =
                    error?.response?.data?.message || error?.message || 'Failed to update destruction';
                toast.error(errorMessage);
            },
        }
    );

    return { updateDestruction, isUpdateDestructionLoading: isLoading };
};

export default useUpdateDestruction;
